<template>
  <b-card no-body>
    <b-card-body>
      <div class="text-right">
        <b-button
          variant="primary"
          :to="$route.path + '/add'"
        >
          <FeatherIcon icon="PlusIcon" /> {{ $t('common.create') }}
        </b-button>
      </div>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="loading"
      :empty-text="emptyText"
      :show-empty="!!emptyText"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
          <strong class="ml-2">{{ $t('common.loading') }}</strong>
        </div>
      </template>
      <template #cell(status)="data">
        <b-badge :variant="data.item.status === 1 ? 'light-success' :'light-danger'">
          <feather-icon
            v-if="data.item.status === 1"
            icon="CheckIcon"
          />
          <feather-icon
            v-if="data.item.status !== 1"
            icon="XIcon"
          />
          {{ data.item.status === 1 ? $t('common.active') : $t('common.passive') }}
        </b-badge>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            :edit-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="String(data.item.id)"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-if="dataCounts > perPage"
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BBadge, BSpinner,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'teams'
export default {
  name: 'Index',
  components: {
    BBadge,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    ListButtons,
    BSpinner,
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.status AS status`,
          'departments.title AS department',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'title',
          label: this.$t('fields.title'),
        },
        {
          key: 'department',
          label: this.$t('fields.department'),
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'status',
          label: this.$t('fields.status'),
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ]
    },
    loading() {
      return this.$store.getters['teams/loading']
    },
    emptyText() {
      if (this.loading === true) {
        return this.$t('common.pleaseWait')
      }
      if (this.dataList.length === 0) {
        return this.$t('common.noData')
      }
      return null
    },
    dataList() {
      return this.$store.getters['teams/dataList']
    },
    dataCounts() {
      return this.$store.getters['teams/dataCounts']
    },
    saveData() {
      return this.$store.getters['teams/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('teams/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$t('alerts.remove.title'),
        text: this.$t('alerts.remove.message'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('alerts.remove.confirm'),
        cancelButtonText: this.$t('alerts.remove.cancel'),
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('teams/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$t('alerts.remove.resultTitle'),
            text: this.$t('alerts.remove.resultMessage'),
            confirmButtonText: this.$t('alerts.remove.resultClose'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
